module.exports = __webpack_public_path__ + "e1fe3705906a6aedd3e1434c3593f652.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/menu/history.svg
// module id = 26
// module chunks = 0